export default __webpack_public_path__ + "static/media/conteudo_extra_10_22.29d8805e.jpg";